import '@missions/ui/styles.css';
import { lastWorkspace } from './FindWorkspace';
import { tempHostUrl, tenantLocation } from '../lib/tenant';

/** Unknown host / slug: neutral page (no tenant branding is known). Rendered without providers. */
export function WorkspaceNotFound() {
  const last = lastWorkspace();
  return (
    <main className="ws-404">
      <img src="/brand/missions-logo.png" alt="Missions" height={28} />
      <h1>Workspace not found</h1>
      <p>
        There’s no workspace at <b>{window.location.host}</b>
        {window.location.pathname.length > 1 ? <b>{window.location.pathname.split('/').slice(0, 2).join('/')}</b> : null}. Check the link you were given, or ask your
        workspace admin for the right address.
      </p>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
        {last && last !== tenantLocation().slug ? (
          <a className="ui-btn primary" href={tempHostUrl(`/${last}/`)}>
            Open {last}
          </a>
        ) : null}
        <a className={`ui-btn${last ? '' : ' primary'}`} href={tempHostUrl('/?pick=1')}>
          Enter a workspace name
        </a>
      </div>
    </main>
  );
}
